module.exports = __webpack_public_path__ + "static/media/Group 8.294ee4ee.png";